export default {"src":"/_next/static/media/yellowcard.d7260421.svg","height":37,"width":163};